import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checkbox", "description", "disabled", "ellipsis", "focused", "hovered", "icon", "id", "isChecked", "isLast", "keyboardFocused", "label", "logoProps", "logoUri", "name", "onClick", "onPress", "pressed", "radio", "shouldRemoveRightTextEllipsis", "testID", "UNSAFE_touchableProps", "useSelectorLogo", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import SelectorOptionBase from '@bubble-ui/temp-selector-option-base';
import Text from '@bubble-ui/primitive-text';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { useDesignContext } from '@klarna/designtokens';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
import defaultTextStyles from '@bubble-ui/particle-default-text-styles';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import Avatar from '@bubble-ui/molecule-avatar';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { omit } from 'ramda';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var BaseSelectorOptionsOption = _ref => {
  var {
      checkbox,
      description,
      disabled,
      ellipsis,
      focused,
      hovered,
      icon,
      id,
      isChecked,
      isLast,
      keyboardFocused,
      label,
      logoProps,
      logoUri,
      name,
      onClick,
      onPress,
      pressed,
      radio,
      shouldRemoveRightTextEllipsis,
      testID,
      UNSAFE_touchableProps,
      useSelectorLogo,
      value
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: checkbox ? 'SelectorOptionsMulti.Option' : radio ? 'SelectorOptions.Option' : '@bubble-ui/temp-base-selector-options-option',
    props,
    useInstead: 'UNSAFE_touchableProps',
    removalDate: 'v7.0.0'
  });
  var designContext = useDesignContext(_objectSpread(_objectSpread({}, defaultColorVariables), defaultTextStyles));
  var designVersion = useDesignVersion();

  // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
  // Keep passing all props to the style sheet, even if we don't use them ourselves
  var {
    leftIconStyle,
    titleStyle,
    paragraphStyle
  } = useStyleSheet(BaseSelectorOptionsOption, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    checkbox,
    description,
    designContext,
    designVersion,
    disabled,
    ellipsis,
    focused,
    hovered,
    icon,
    id,
    isChecked,
    isLast,
    keyboardFocused,
    label,
    logoUri,
    logoProps,
    name,
    onClick,
    onPress,
    overflowEllipsisWidth: ellipsis ? '100%' : undefined,
    pressed,
    radio,
    shouldRemoveRightTextEllipsis,
    testID,
    useSelectorLogo,
    value
  }));
  return /*#__PURE__*/React.createElement(SelectorOptionBase, _extends({
    UNSAFE_touchableProps: UNSAFE_touchableProps
  }, useSelectorLogo ? {
    logo: /*#__PURE__*/React.createElement(Avatar, _extends({
      icon: logoProps && logoProps.icon,
      source: logoUri,
      fallbackCharacter: (logoProps === null || logoProps === void 0 ? void 0 : logoProps.label) || (label === null || label === void 0 ? void 0 : label[0])
    }, omit(['label'], logoProps))),
    logoProps,
    isRightTextEllipsis: !shouldRemoveRightTextEllipsis
  } : {}, {
    disabled: disabled,
    leftIcon: icon && /*#__PURE__*/React.cloneElement(icon, leftIconStyle(icon)),
    checkbox: checkbox,
    checked: isChecked,
    text: /*#__PURE__*/React.createElement(Text, {
      numberOfLines: ellipsis ? 1 : 0,
      tag: "h2",
      style: titleStyle
    }, label),
    description: description ? /*#__PURE__*/React.createElement(Text, {
      numberOfLines: ellipsis ? 1 : 0,
      tag: "paragraph",
      style: paragraphStyle
    }, description) : undefined,
    focused: focused,
    hovered: hovered,
    id: id,
    isLast: isLast,
    keyboardFocused: keyboardFocused,
    name: name,
    onClick: onClick,
    onPress: onPress,
    pressed: pressed,
    radio: radio,
    testID: testID,
    value: value
  }, props));
};
BaseSelectorOptionsOption.displayName = 'SelectorOptions';
export default withProvisionalOverrideFromContext(BaseSelectorOptionsOption);
//# sourceMappingURL=index.js.map